module.exports = __webpack_public_path__ + "img/powered_by_soundcloud.55707035.png";